import React, { Component } from "react";
import FakeData from '.././fake-data';
import './SoccerPitch.css';
import { AddPlayer } from './Squads'

export default class SoccerPitch extends Component {
    constructor(p) {
        super(p);
        this.state = {
            isDrawing: false,
            isAnimating: false,
            frameCount: 0,
            timeout: 2000,
            isPlaying: false,
            isEdittingFrame: false,
            clickX: [],
            clickY: [],
            clickDrag: [],
            currentColor: "#fff",
            clickColor: [],
            isAddingPlayer: false,
            subs: FakeData.getDummy(this.props.maxSubs, {
                x: 0,
                y: 0
            }),
            currentFrame: null,
            lineup: (this.props.lineup) ? this.props.lineup : [],
            frames: [],
            currentFrameIndex: 0,
            ball: {
                x: 49,
                y: 49,
                isHidden: false
            },
            players: [],
            filteredPlayers: [],
            value: ""
        }

        this.frames = []
        this.lineup = []
        this.subs = FakeData.getDummy(this.props.maxSubs, {
            x: 0,
            y: 0
        })
        this.onSearchChange = this.onSearchChange.bind(this);
    }

    componentDidMount() {
        const _that = this
        this.setState({
            players: FakeData.listify(this.props.players),
            filteredPlayers: FakeData.listify(this.props.players),
            lineup: (this.props.lineup) ? this.props.lineup : [],
            subs: (this.props.subs && this.props.subs.length > 3) ? this.props.subs : FakeData.getDummy(this.props.maxSubs?this.props.maxSubs:5,{x:0,y:0}),
        });
        setTimeout(()=>{
            _that.checkLinedUp()
        }, 1000)
    }

    checkLinedUp() {
        const { subs, players, lineup } = this.state;
        players.forEach((item, i) => {
            let list = lineup;
            let index = lineup.findIndex((data) => data.id == item.id);
            if (index > -1) {
                this.disablePlayer(item.id)
            }
        })
    }

    disablePlayer(id) {
        let list = this.state.players;
        let index = this.state.players.findIndex((item) => item.id == id);
        list[index].selected = true;
        this.setState({
            players: list
        });

        this.onSearchChange(this.state.value)
    }

    onSetPlayer(obj, i) {
        let list = this.state.subs;
        const { x, y } = list[i]
        let item = list[i];
        item = obj
        item.x = x;
        item.y = y;
        list[i] = item;
        this.setState({
            subs: list
        });
        this.disablePlayer(item.id)
    }

    substitutePlayer(id, player) {
        if (this.state.isEdittingFrame || this.state.isAnimating || this.state.isPlaying) {
            return;
        }
        let list = this.state.subs;
        let index = this.state.subs.findIndex((item) => item.id == id);
        list[index] = player
        list[index].hasPlayed = true;

        this.setState({
            subs: list
        });
    }

    populateState(key, data) {
        if (this.state.isEdittingFrame && (key === "lineup" || key === "subs")) {
            let _frames = this.state.frames;
            let index = this.state.currentFrameIndex;
            const _frame = _frames[index]
            data.forEach((item, i) => {
                const pos = _frame[key].findIndex((d) => d.idOf === item.id)
                if (pos > -1) {
                    _frame[key][pos].x = item.x;
                    _frame[key][pos].y = item.y;
                    _frames[index] = _frame
                    this.setState({
                        frames: _frames,
                        key: data
                    });
                }
            });
            return;
        } else {
            this.setState({ key: data });
        }
    }

    populateFullState(arr, data) {
        if (this.state.isEdittingFrame) {
            let _frames = this.state.frames;
            let index = this.state.currentFrameIndex;
            const _frame = _frames[index]
            arr.forEach((item, i) => {
                if (item === "ball") {
                    _frame.ball = data.ball
                    _frames[index] = _frame
                    this.setState({
                        frames: _frames,
                        ball: data.ball
                    });
                } else {
                    const _data = data[item];
                    const _key = item;
                    //_frames[index][item] = data[item];
                    _data.forEach((_item, i) => {
                        const pos = _frame[_key].findIndex((d) => d.idOf === _item.id)
                        if (pos > -1) {
                            _frame[_key][pos].val = _item.val;
                            _frames[index] = _frame
                            this.setState({
                                frames: _frames,
                                _key: _data
                            });
                        }
                    });
                }
            })
            this.setState({
                frames: _frames,
                data
            });
            return;
        } else {
            this.setState(data);
        }
    }

    movePlayer(id, obj) {
        let list = this.state.lineup;
        let index = this.state.lineup.findIndex((item) => item.id == id);
        list[index].x = obj.x
        list[index].y = obj.y;

        this.setState({
            lineup: list
        });
    }

    addFrame() {
        const { lineup, subs, frames, clickColor, clickDrag, clickX, clickY, ball } = this.state
        const _frame = { id: Date.now(), lineup: [], subs: subs, clickColor: [], clickX: [], clickDrag: [], clickY: [], ball: { x: 0, y: 0, isHidden: false } }
        lineup.forEach((item, i) => {
            const obj = {
                idOf: item.id,
                x: item.x,
                y: item.y
            }

            _frame.lineup.push(obj)
        });

        clickColor.forEach((item, i) => {
            const obj = {
                idOf: item.id,
                val: item.val,
            }

            _frame.clickColor.push(obj)
        });

        clickDrag.forEach((item, i) => {
            const obj = {
                idOf: item.id,
                val: item.val,
            }

            _frame.clickDrag.push(obj)
        });

        clickX.forEach((item, i) => {
            const obj = {
                idOf: item.id,
                val: item.val,
            }

            _frame.clickX.push(obj)
        });

        clickX.forEach((item, i) => {
            const obj = {
                idOf: item.id,
                val: item.val,
            }

            _frame.clickX.push(obj)
        });

        _frame.ball.x = ball.x,
            _frame.ball.y = ball.y
        _frame.ball.isHidden = ball.isHidden

        frames.push(_frame)
        this.setState({ frames });
        FakeData.alert("Frame was added");
    }

    playAnim() {
        this.setState({ isPlaying: true });
        const { frames, currentFrameIndex } = this.state
        this.play(frames[currentFrameIndex])
    }

    play(obj) {
        const _that = this
        //console.log("playing...")
        const { lineup, subs, ball, clickColor, clickDrag, clickX, clickY } = this.state
        ball.isHidden = true
        lineup.forEach((data, x) => {
            lineup[x].isHidden = true
        });

        clickColor.forEach((data, x) => {
            clickColor[x].isHidden = true
        });

        clickDrag.forEach((data, x) => {
            clickDrag[x].isHidden = true
        });

        clickX.forEach((data, x) => {
            clickX[x].isHidden = true
        });

        clickY.forEach((data, x) => {
            clickY[x].isHidden = true
        });

        this.setState({ lineup, ball, clickColor, clickDrag, clickX, clickY });

        obj.lineup.forEach((item, i) => {
            lineup.forEach((data, x) => {
                if (data.id === item.idOf) {
                    lineup[x].x = item.x;
                    lineup[x].y = item.y;
                    lineup[x].isHidden = false
                }
            });
        })

        //clickColor Up moves
        obj.clickColor.forEach((item, i) => {
            clickColor.forEach((data, x) => {
                if (data.id === item.idOf) {
                    clickColor[x].val = item.val;
                    clickColor[x].isHidden = false
                }
            });
        })

        //clickDrag Up moves
        obj.clickDrag.forEach((item, i) => {
            clickDrag.forEach((data, x) => {
                if (data.id === item.idOf) {
                    clickDrag[x].val = item.val;
                    clickDrag[x].isHidden = false
                }
            });
        })

        //clickX Up moves
        obj.clickX.forEach((item, i) => {
            clickX.forEach((data, x) => {
                if (data.id === item.idOf) {
                    clickX[x].val = item.val;
                    clickX[x].isHidden = false
                }
            });
        })

        //clickY Up moves
        obj.clickY.forEach((item, i) => {
            clickY.forEach((data, x) => {
                if (data.id === item.idOf) {
                    clickY[x].val = item.val;
                    clickY[x].isHidden = false
                }
            });
        })

        this.setState({ lineup, ball: obj.ball, clickColor, clickDrag, clickX, clickY });

        setTimeout(() => {
            _that.end()
        }, this.state.timeout)
    }

    end() {
        if (!this.state.isPlaying) {
            return;
        }
        const _that = this
        const { frames, currentFrameIndex } = this.state
        let curr = currentFrameIndex + 1
        if (currentFrameIndex === (frames.length - 1)) {
            _that.setState({ currentFrameIndex: 0 });
            setTimeout(() => {
                _that.playAnim()
            }, 100)
        } else {
            _that.setState({ currentFrameIndex: curr });
            setTimeout(() => {
                _that.playAnim()
            }, 100)
        }
    }

    showAll() {
        //console.log("playing...")
        const { lineup, subs, ball, clickColor, clickDrag, clickX, clickY } = this.state
        ball.isHidden = false
        lineup.forEach((data, x) => {
            lineup[x].isHidden = false
        });

        clickColor.forEach((data, x) => {
            clickColor[x].isHidden = false
        });

        clickDrag.forEach((data, x) => {
            clickDrag[x].isHidden = false
        });

        clickX.forEach((data, x) => {
            clickX[x].isHidden = false
        });

        clickY.forEach((data, x) => {
            clickY[x].isHidden = false
        });

        this.setState({ lineup, ball, clickColor, clickDrag, clickX, clickY });
    }

    clearBoard() {
        this.setState({
            clickX: [],
            clickY: [],
            clickDrag: [],
            currentColor: "#fff",
            clickColor: []
        });
    }

    editFrame(pos, obj) {
        const _that = this
        //console.log("playing...")
        const { lineup, subs, ball, clickColor, clickDrag, clickX, clickY } = this.state
        ball.isHidden = true
        lineup.forEach((data, x) => {
            lineup[x].isHidden = true
        });

        clickColor.forEach((data, x) => {
            clickColor[x].isHidden = true
        });

        clickDrag.forEach((data, x) => {
            clickDrag[x].isHidden = true
        });

        clickX.forEach((data, x) => {
            clickX[x].isHidden = true
        });

        clickY.forEach((data, x) => {
            clickY[x].isHidden = true
        });

        this.setState({ lineup, ball, clickColor, clickDrag, clickX, clickY });

        ball.x = obj.ball.x;
        ball.y = obj.ball.y;
        ball.isHidden = obj.ball.isHidden
        //Line Up moves
        obj.lineup.forEach((item, i) => {
            lineup.forEach((data, x) => {
                if (data.id === item.idOf) {
                    lineup[x].x = item.x;
                    lineup[x].y = item.y;
                    lineup[x].isHidden = false
                }
            });
        })

        //clickColor Up moves
        obj.clickColor.forEach((item, i) => {
            clickColor.forEach((data, x) => {
                if (data.id === item.idOf) {
                    clickColor[x].val = item.val;
                    clickColor[x].isHidden = false
                }
            });
        })

        //clickDrag Up moves
        obj.clickDrag.forEach((item, i) => {
            clickDrag.forEach((data, x) => {
                if (data.id === item.idOf) {
                    clickDrag[x].val = item.val;
                    clickDrag[x].isHidden = false
                }
            });
        })

        //clickX Up moves
        obj.clickX.forEach((item, i) => {
            clickX.forEach((data, x) => {
                if (data.id === item.idOf) {
                    clickX[x].val = item.val;
                    clickX[x].isHidden = false
                }
            });
        })

        //clickY Up moves
        obj.clickY.forEach((item, i) => {
            clickY.forEach((data, x) => {
                if (data.id === item.idOf) {
                    clickY[x].val = item.val;
                    clickY[x].isHidden = false
                }
            });
        })

        this.setState({ lineup, ball, clickColor, clickDrag, clickX, clickY, currentFrameIndex: pos, isEdittingFrame: true });
    }

    getJerseys = () => {
        const list = [];
        const { players } = this.state;
        players.forEach((item, i) => {
            if (!FakeData.inArray(item.number, list)) {
                list.push(item.number)
            }
        })

        return list
    }

    onSearchChange = (value) => {
        const { players } = this.state
        const list = []
        players.forEach((item, i) => {
            if (FakeData.nullify(item.name).toLowerCase().indexOf(value.toLowerCase()) > -1) {
                list.push(item)
                this.setState({ filteredPlayers: list });
            }
        })
    }

    save = () => {
        const { subs, players, lineup } = this.state
        const { team, readOnly, isGMC, canSave, maxLineup, maxSubs } = this.props
        if (lineup.length < maxLineup) {
            FakeData.alert("Players in your lineup are less than " + maxLineup + ", Add more players!")
            return;
        }

        let bool = false

        subs.forEach((item, i) => {
            if (!item.id) {
                bool = true
            }
        })

        if (bool) {
            FakeData.alert("Players in your substitutes are less than " + maxSubs + ", Add more players!")
            return;
        }

        this.props.onSave(players, lineup, subs)
    }

    render() {
        const { value, subs, players, filteredPlayers, ball, lineup, timeout, isPlaying, clickX, clickDrag, clickY, clickColor, currentColor, currentFrameIndex, isEdittingFrame, isAddingPlayer } = this.state
        const { team, readOnly, isGMC, canSave } = this.props
        return (
            <div className="soccer-ground-holder" ref={"pitch"}>
                {!readOnly &&
                    <div className="soccer-ground-player-list" style={{ maxHeight: (isGMC) ? "600px" : "800px" }}>
                        {(this.props.isBoard || this.props.isGMC) &&
                            <div className="soccer-ground-player-list-head">
                                <h4>All Players</h4>
                                <button onClick={() => this.setState({ isAddingPlayer: true })}>Add a new player</button>
                            </div>
                        }
                        {(!this.props.isBoard && !this.props.isGMC) &&
                            <h4>All Players</h4>
                        }
                        {((this.props.isBoard || this.props.isGMC) && players.length > 10) &&
                            <div className="soccer-ground-player-list-search" style={{ width: "100%" }}>
                                <input placeholder="Search player.." style={{ width: "100%", padding: "4px !important", color: "#000", border: "0.3px solid #aaa !important", marginBottom: "4px" }} value={value} onChange={(e) => {
                                    this.setState({ value: e.target.value });
                                    this.onSearchChange(e.target.value)
                                }} />
                            </div>
                        }
                        <div className="soccer-ground-player-list-holder">
                            {
                                filteredPlayers.map((item, i) => {
                                    return (
                                        <PlayerItem key={i} player={item} isSelected={(item.selected) ? false : true} />
                                    )
                                })
                            }
                        </div>
                    </div>
                }
                <div className={"soccer-ground-field "+FakeData.nullify(this.props.sport.toLowerCase()).replace(" ","-")} style={{ width: (readOnly) ? "100%" : "65%" }}>
                    <div className="soccer-ground-field-layer">
                        <SoccerPitchHf isGMC={(readOnly) ? true : false} max={this.props.maxLineup} populateFullState={this.populateFullState.bind(this)} ball={ball} isDrawing={this.state.isDrawing} isPlaying={isPlaying} timeout={timeout} movePlayer={this.movePlayer.bind(this)} populateState={this.populateState.bind(this)} players={lineup} disablePlayer={this.disablePlayer.bind(this)} substitutePlayer={this.substitutePlayer.bind(this)} />
                        {(!this.state.isAnimating) &&
                            <div className="soccer-ground-field-layer-subs">
                                {
                                    subs.map((item, i) => {
                                        if (i > (this.props.maxSubs - 1)) {
                                            return null;
                                        }
                                        return (
                                            <SubPlayer canDrop={(!item.id) ? true : false} pos={i} key={i} id={(!item.id) ? "empty_" + 1 : item.id} setPlayer={this.onSetPlayer.bind(this)} player={item} isDragging={(!item.id) ? false : true} />
                                        )
                                    })
                                }
                            </div>
                        }
                        {!readOnly &&
                            <DrawingBoard getParent={() => {
                                return this.refs.pitch
                            }} onCloseBoard={(data) => {
                                this.setState({ isDrawing: false });
                            }} populateFullState={this.populateFullState.bind(this)}
                                clickX={clickX}
                                clickDrag={clickDrag}
                                clickY={clickY}
                                clickColor={clickColor}
                                currentColor={currentColor}
                                clear={this.clearBoard.bind(this)}
                                isDrawing={this.state.isDrawing}
                                isPlaying={isPlaying}
                            />
                        }
                        {!readOnly &&
                            <div className="soccer-ground-field-layer-ctrls">
                                {this.isPlaying &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={() => {
                                        ball.isHidden = !ball.isHidden
                                        this.setState({ ball });
                                    }}>
                                        {(ball.isHidden) ? "Show" : "Hide"} Ball
                                </div>
                                }
                                {!this.state.isAnimating &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={this.save.bind(this)}>
                                        Save Formation
                                </div>
                                }
                                {!this.state.isDrawing &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={() => {
                                        this.setState({ isDrawing: true });
                                    }}>
                                        Open Board
                                    </div>
                                }
                                {!this.state.isAnimating &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={() => {
                                        this.setState({ isAnimating: true, frameCount: 1 });
                                    }}>
                                        {(this.state.frames.length === 0) ? "Create Animation" : "Show Animation"}
                                    </div>
                                }
                                {(this.state.isAnimating && !isPlaying && !isEdittingFrame) &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={this.addFrame.bind(this)}>
                                        Add Frame
                                </div>
                                }
                                {(this.state.isAnimating && !isPlaying && isEdittingFrame) &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={() => {
                                        this.setState({ isEdittingFrame: false });
                                    }}>
                                        Close Frame Edit
                                </div>
                                }
                                {(this.state.isAnimating && !isPlaying && this.state.frames.length > 0) &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={this.playAnim.bind(this)}>
                                        Play
                                </div>
                                }
                                {(this.state.isAnimating && isPlaying) &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={() => {
                                        this.setState({ isPlaying: false });
                                        this.showAll()
                                    }}>
                                        Pause
                                </div>
                                }
                                {(this.state.isAnimating && isPlaying) &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={() => {
                                        this.setState({ isPlaying: false, currentFrameIndex: 0 });
                                        this.showAll()
                                    }}>
                                        Stop
                                </div>
                                }
                                {(this.state.isAnimating && !isPlaying && !isEdittingFrame) &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={() => {
                                        this.setState({ isAnimating: false, frames: [] });
                                        this.showAll()
                                    }}>
                                        Reset
                                </div>
                                }
                                {(this.state.isAnimating && !isPlaying && !isEdittingFrame) &&
                                    <div className="soccer-ground-field-layer-ctrl" onClick={() => {
                                        this.setState({ isAnimating: false });
                                    }}>
                                        {(this.state.frames.length === 0) ? "Cancel Animation" : "Hide Animation"}
                                    </div>
                                }
                            </div>
                        }
                        {(this.state.isAnimating && this.state.frames.length > 0) &&
                            <div className="animation-frames">
                                {
                                    this.state.frames.map((item, i) => {
                                        return (
                                            <div className={(currentFrameIndex === i) ? "animation-frame active" : (currentFrameIndex > i) ? "animation-frame inactive" : "animation-frame"} key={i} onClick={() => {
                                                this.setState({ currentFrameIndex: i });
                                            }}>
                                                <span>{i + 1}</span>
                                                {!isPlaying &&
                                                    <div className="animation-frame-ctrls">
                                                        <span onClick={() => this.editFrame(i, item)}>Edit</span>
                                                        <span onClick={() => {
                                                            this.state.frames.splice(i, 1)
                                                            this.setState({ frames: this.state.frames, currentFrameIndex: (currentFrameIndex === i) ? 0 : currentFrameIndex });
                                                        }}>Remove</span>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                </div>
                {isAddingPlayer &&
                    <AddPlayer jerseyArray={this.getJerseys()} sport={this.props.sport.toLowerCase()} isOpen={isAddingPlayer} teamId={team.id} squadId={team.squadId} gender={team.gender} name={team.name} onClose={(player) => {
                        if (player === null) {
                            this.setState({ isAddingPlayer: false })
                            return;
                        } else {
                            players.push(player)
                            this.setState({ isAddingPlayer: false, players })
                            return;
                        }
                    }} />
                }
            </div>
        );
    }
}

export class DrawingBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            image: null,
            isPainting: false,
            clickX: [],
            clickY: [],
            clickDrag: [],
            color: ["#f43", "#fff", "#222", "#4a5", "#29b"],
            currentColor: "#fff",
            clickColor: [],
            colorUndo: [],
            clickXUndo: [],
            clickYUndo: [],
            clickDragUndo: []
        }

        this.redraw = this.redraw.bind(this);
        this.addClick = this.addClick.bind(this);
    }

    componentDidMount() {
        FakeData.mountState("draw-board", true)
        this._isMounted = true
        this.canvas = this.refs.canvas;
        this._context = this.canvas.getContext("2d");
        this.prepare()
    }

    componentWillUnmount() {
        this._isMounted = false
        FakeData.mountState("draw-board", false)
    }

    prepare() {
        this.canvas.setAttribute('width', this._context.canvas.clientWidth);
        this.canvas.setAttribute('height', this._context.canvas.clientHeight);
        const _that = this
        setTimeout(() => {
            _that.redraw()
        }, 50)
    }

    componentWillReceiveProps(nextProps) {
        //this.canvas = this.refs.canvas;
        //this._context = this.canvas.getContext("2d");
        const _that = this;
        if (!this._isMounted || !this.canvas) {
            return;
        }
        
        if (nextProps.clickX.length === 0) {
            setTimeout(() => {
                //console.log(_that.canvas)
                //console.log(_that._context)
                _that._context.clearRect(0, 0, _that._context.canvas.clientWidth, _that._context.canvas.clientHeight);
            }, 200)
        }
    }

    addClick(x, y, dragging) {
        const { clickX, clickDrag, clickY, clickColor, currentColor } = this.props
        clickX.push(x);
        clickY.push(y);
        clickDrag.push(dragging);
        clickColor.push({ id: "c" + Date.now(), val: currentColor })
        //this.setState({ clickX, clickDrag, clickY, clickColor });
        this.props.populateFullState(["clickX", "clickDrag", "clickY", "clickColor"], { clickX, clickDrag, clickY, clickColor })
    }

    redraw() {
        if (!FakeData.isMounted("draw-board")) {
            //return;
        }
        const _that = this
        const { clickX, clickDrag, clickY, clickColor } = this.props
        this._context.clearRect(0, 0, this._context.canvas.clientWidth, this._context.canvas.clientHeight); // Clears the canvas

        //this._context.strokeStyle = "#f43";
        this._context.lineJoin = "round";
        this._context.lineWidth = 5;

        for (var i = 0; i < clickX.length; i++) {
            if (clickX[i].isHidden) {
                continue;
            }

            this._context.beginPath();
            if (clickDrag[i].val && i) {
                this._context.moveTo(clickX[i - 1].val, clickY[i - 1].val);
            } else {
                this._context.moveTo(clickX[i].val - 1, clickY[i].val);
            }
            this._context.lineTo(clickX[i].val, clickY[i].val);
            this._context.closePath();
            this._context.strokeStyle = clickColor[i].val;
            this._context.stroke();
        }

        setTimeout(() => {
            _that.redraw();
        }, 50)
    }

    onMouseDown(e) {
        if (!this.props.isDrawing) {
            return;
        }
        var mouseX = e.pageX - this._context.canvas.offsetLeft;
        var mouseY = e.pageY - this._context.canvas.offsetTop;
        const offset = window.$(this.canvas).offset();

        this.setState({ isPainting: true });
        this.addClick({ id: "x" + Date.now(), val: e.pageX - offset.left, isHidden: false }, { id: "y" + Date.now(), val: e.pageY - offset.top, isHidden: false }, { id: "d" + Date.now(), val: false, isHidden: false });
        //this.redraw();
    }

    onMouseMove(e) {
        if (!this.props.isDrawing) {
            return;
        }
        const { isPainting } = this.state
        const offset = window.$(this.canvas).offset();
        if (isPainting) {
            this.addClick({ id: "x" + Date.now(), val: e.pageX - offset.left, isHidden: false }, { id: "y" + Date.now(), val: e.pageY - offset.top, isHidden: false }, { id: "d" + Date.now(), val: true, isHidden: false });
            //this.redraw();
        }
    }

    onMouseUp(e) {
        this.setState({ isPainting: false });
    }

    onMouseLeave(e) {
        this.setState({ isPainting: false });
    }

    redo() {
        const { clickDragUndo, clickXUndo, colorUndo, clickYUndo } = this.state
        const { clickX, clickDrag, clickY, clickColor, currentColor } = this.props
        if (clickXUndo.length === 0) {
            return;
        }
        clickDrag.push(clickDragUndo[clickDragUndo.length - 1]);
        clickX.push(clickXUndo[clickXUndo.length - 1])
        clickY.push(clickYUndo[clickYUndo.length - 1]);
        clickColor.push(colorUndo[colorUndo.length - 1]);
        let lastColor = colorUndo[colorUndo.length - 1];

        clickDragUndo.splice(clickDragUndo.length - 1, 1)
        clickXUndo.splice(clickXUndo.length - 1, 1)
        clickYUndo.splice(clickYUndo.length - 1, 1)
        colorUndo.splice(colorUndo.length - 1, 1)
        this.setState({ clickDragUndo, clickXUndo, colorUndo, clickYUndo });
        this.props.populateFullState(["clickX", "clickDrag", "clickY", "clickColor"], { clickX, clickDrag, clickY, clickColor, currentColor: lastColor })
        this.redraw();
    }

    undo() {
        const { clickDragUndo, clickXUndo, colorUndo, clickYUndo } = this.state
        const { clickX, clickDrag, clickY, clickColor, currentColor } = this.props
        if (clickX.length === 0) {
            return;
        }

        clickDragUndo.push(clickDrag[clickDrag.length - 1]);
        clickXUndo.push(clickX[clickX.length - 1])
        clickYUndo.push(clickY[clickY.length - 1]);
        colorUndo.push(clickColor[clickColor.length - 1]);
        let lastColor = clickColor[clickColor.length - 1];

        clickX.splice(clickX.length - 1, 1)
        clickY.splice(clickY.length - 1, 1)
        clickDrag.splice(clickDrag.length - 1, 1)
        clickColor.splice(clickColor.length - 1, 1)
        this.setState({ clickDragUndo, clickXUndo, colorUndo, clickYUndo });
        this.props.populateFullState(["clickX", "clickDrag", "clickY", "clickColor"], { clickX, clickDrag, clickY, clickColor, currentColor: lastColor })
        this.redraw();
    }

    save() {
        const { clickX, clickDrag, clickY, clickColor, clickDragUndo, clickXUndo, colorUndo, clickYUndo } = this.state
        if (clickX.length === 0) {
            return;
        }
    }

    onClose() {
        this.props.onCloseBoard(null)
    }

    render() {
        return (
            <div className="soccer-ground-field-layer-board" style={{ zIndex: (this.props.isDrawing) ? 2 : 1 }}>
                {(this.props.isDrawing && !this.props.isPlaying) &&
                    <div className="soccer-ground-field-layer-board-ctrls">
                        <div className="soccer-ground-field-layer-board-ctrl-colors">
                            {
                                this.state.color.map((item, i) => {
                                    return (
                                        <div key={i} style={{ backgroundColor: item }} onClick={() => {
                                            this.props.populateFullState([], { currentColor: item })
                                        }} />
                                    )
                                })
                            }
                        </div>
                        <div className="soccer-ground-field-layer-board-ctrl-actions">
                            <div onClick={this.undo.bind(this)} className={(this.props.clickX.length === 0) ? "disabled" : ""}>Undo</div>
                            <div onClick={this.redo.bind(this)} className={(this.state.clickXUndo.length === 0) ? "disabled" : ""}>Redo</div>
                            <div onClick={this.save.bind(this)} className={(this.props.clickX.length === 0) ? "disabled" : ""}>Save</div>
                            <div onClick={this.props.clear}>Clear</div>
                            <div onClick={this.onClose.bind(this)}>Hide</div>
                        </div>
                    </div>
                }
                <canvas ref={"canvas"}
                    className={"pitch-canvas"}
                    onMouseDown={this.onMouseDown.bind(this)}
                    onMouseLeave={this.onMouseLeave.bind(this)}
                    onMouseMove={this.onMouseMove.bind(this)}
                    onMouseUp={this.onMouseUp.bind(this)}
                    onTouchStart={this.onMouseDown.bind(this)}
                    onTouchCancel={this.onMouseLeave.bind(this)}
                    onTouchMove={this.onMouseMove.bind(this)}
                    onTouchEnd={this.onMouseUp.bind(this)}
                />
            </div>
        );
    }
}

export class SoccerPitchHf extends Component {
    constructor(p) {
        super(p);
        this.state = {
            context: null,
        }
    }

    onDragOver(e) {
        //console.log(e)
        //console.log(e.clientY,e.pageY)
        //console.log(e.clientX,e.pageY)
        e.preventDefault()
        return false;
    }

    onDrop(e) {
        const { players, max, isPlaying } = this.props
        if (isPlaying) {
            return;
        }
        var obj = JSON.parse(e.dataTransfer.getData('application/json'));
        if (obj.isBall) {
            let ball = this.state.ball;
            const w = window.$(e.currentTarget).width();
            const h = window.$(e.currentTarget).height();
            ball.y = ((e.pageY - obj.y) / h) * 100;
            ball.x = ((e.pageX - obj.x) / w) * 100;
            this.props.populateFullState(["ball"], { ball })
        } else {
            const offset = window.$(e.currentTarget).offset();
            const w = window.$(e.currentTarget).width();
            const h = window.$(e.currentTarget).height();
            let list = players;
            let index = players.findIndex((item) => item.id == obj.id);
            if (obj.fromSub) {
                return;
            } else if (index === -1) {
                if (players.length === max) {
                    return;
                }
                const item = obj;
                obj.x = ((e.pageX - offset.left) / w) * 100;
                obj.y = ((e.pageY - offset.top) / h) * 100;
                list.push(obj)

                this.props.populateState("lineup", list);
                this.props.disablePlayer(item.id)
            } else {
                //console.log(obj.x, obj.y)
                //console.log(e.pageX, e.pageY)
                list[index].isDragging = false;
                list[index].y = ((e.pageY - obj.y) / h) * 100;
                list[index].x = ((e.pageX - obj.x) / w) * 100;

                let newState = Object.assign(
                    {}, {
                        lineup: list
                    });
                this.props.populateState("lineup", list);
            }
        }

        e.preventDefault();
    }

    updateStateDragging(id, isDragging) {
        const { players } = this.props
        let list = players;
        let index = players.findIndex((item) => item.id == id);
        list[index].isDragging = isDragging;

        this.props.populateState("lineup", list);
    }

    onSetPlayer(obj, i) {
        const { players } = this.props
        let list = players;
        const { x, y } = list[i]
        let item = list[i];
        item = obj
        item.x = x;
        item.y = y;
        list[i] = item;
        this.props.populateState("lineup", list);
        this.props.disablePlayer(item.id)
    }

    onSubstitutePlayer(obj, i) {
        const { players } = this.props
        let list = players;
        if (!list[i].id) {
            return;
        }
        const { x, y } = list[i]
        const oldPlayer = list[i];
        let item = list[i];
        item = obj
        item.x = x;
        item.y = y;
        list[i] = item;
        this.props.populateState("lineup", list);
        this.props.substitutePlayer(item.id, oldPlayer)
    }

    dataBallTransfer(obj) {
        console.log(obj)
        let ball = this.state.ball;
        const offset = window.$(this.refs.elem).offset();
        const w = window.$(this.refs.elem).width();
        const h = window.$(this.refs.elem).height();
        ball.y = ((offset.top - obj.y) / h) * 100;
        ball.x = ((offset.left - obj.x) / w) * 100;
        //this.setState({ball});
    }

    render() {
        const { players, ball } = this.props
        return (
            <div className="soccer-picth-hf" ref={"ground"}
                onDragOver={this.onDragOver.bind(this)}
                onDrop={this.onDrop.bind(this)}
                ref={"elem"}
                style={{ zIndex: (!this.props.isDrawing) ? 2 : 1 }}
            >
                {
                    players.map((item, i) => {
                        return (
                            <Player
                                getParent={() => { return this.refs.elem }}
                                ref={"node_" + item.id}
                                key={(!item.id) ? "empty_" + i : item.id}
                                id={item.id}
                                top={item.y + "%"}
                                left={item.x + "%"}
                                isPlaying={this.props.isPlaying}
                                timeout={this.props.timeout}
                                canDrop={(!item.id) ? true : false}
                                pos={i}
                                item={item}
                                isDragging={(!item.id && !this.props.isPlaying && !this.props.isGMC) ? false : item.isDragging}
                                updateStateDragging={this.updateStateDragging.bind(this)}
                                setPlayer={this.onSetPlayer.bind(this)}
                                substitutePlayer={this.onSubstitutePlayer.bind(this)}
                                movePlayer={this.props.movePlayer}
                            />
                        )
                    })
                }
                {this.isAnimating &&
                    <Ball
                        getParent={() => { return this.refs.elem }}
                        ref={"node_ball"}
                        key={"empty_ball"}
                        id={"ball"}
                        top={ball.y + "%"}
                        left={ball.x + "%"}
                        isHidden={ball.isHidden}
                        isDragging={!this.props.isPlaying}
                        dataBallTransfer={this.dataBallTransfer.bind(this)}
                    />
                }
            </div>
        );
    }
}

export class Player extends Component {
    constructor(p) {
        super(p);
        this.state = {

        }
    }

    onDragOver(e) {
        e.preventDefault()
        return false;
    }

    onDrop(e) {
        if (this.props.canDrop) {
            var obj = JSON.parse(e.dataTransfer.getData('application/json'));
            if (obj.fromLineUp && !this.props.item.id) {
                this.props.setPlayer(obj, this.props.pos)
            }
        } else if (this.props.item.id) {
            var obj = JSON.parse(e.dataTransfer.getData('application/json'));
            if (obj.fromSub) {
                this.props.substitutePlayer(obj, this.props.pos)
            }
        }
        e.preventDefault();
    }

    onMouseDown(e) {
        if (this.props.isGMC) {
            return;
        }
        var elm = document.elementFromPoint(e.clientX, e.clientY);
        this.props.updateStateDragging(this.props.id, true);
    }

    onMouseUp(e) {
        this.props.updateStateDragging(this.props.id, false);
    }

    onMouseLeave(e) {
        this.props.updateStateDragging(this.props.id, false);
    }

    onDragStart(e) {
        const nodeStyle = this.refs.node.style;
        const offset = window.$(this.props.getParent()).offset;
        const w = window.$(this.props.getParent()).width();
        const h = window.$(this.props.getParent()).height();
        const left = (parseInt(nodeStyle.left) / 100) * w;
        const top = (parseInt(nodeStyle.top) / 100) * h;
        //console.log("Dragged I", left, top)
        //console.log("Dragged E", e.clientX, e.clientY)
        const evt = e || window.event;
        var posX = e.clientX;
        var posY = e.clientY;
        var aX = posX - left;
        var aY = posY - top;
        var boun = this.props.getParent().offsetWidth - this.refs.node.offsetWidth;
        if ((aX > 0) && (aX < boun) && (aY > 0) && (aY < boun)) {
            e.dataTransfer.setData('application/json', JSON.stringify({
                id: this.props.id,
                // mouse position in a draggable element
                x: aX,
                y: aY,
            }));
        }

        //e.preventDefault()
    }

    onDragEnd(e) {
        this.props.updateStateDragging(this.props.id, false);
    }

    render() {
        //console.log(this.props.getParent())
        const { item } = this.props
        const styles = {
            top: this.props.top,
            left: this.props.left,
            opacity: (item.isHidden) ? 0 : 1
        };

        return (
            <div
                className={(this.props.canDrop) ? "player" : "player ready"}
                ref={"node"}
                draggable={this.props.isDragging}
                id={'item_' + this.props.id}
                style={styles}
                onMouseDown={this.onMouseDown.bind(this)}
                onMouseUp={this.onMouseUp.bind(this)}
                onDragStart={this.onDragStart.bind(this)}
                onTouchMove={this.onDragStart.bind(this)}
                onTouchStart={this.onMouseDown.bind(this)}
                onTouchEnd={this.onMouseUp.bind(this)}
                onDragEnd={this.onDragEnd.bind(this)}
                onDragOver={this.onDragOver.bind(this)}
                onDrop={this.onDrop.bind(this)}
                tabIndex={0}
            >
                {!this.props.canDrop &&
                    <img src={item.image} draggable={/*this.props.isDragging*/ false} />
                }
                {!this.props.canDrop &&
                    <span>{item.name}</span>
                }
                {!this.props.canDrop &&
                    <div className="play-card">
                        <div className="play-card-head">
                            <span>{item.name}</span>
                        </div>
                        <div className="play-card-body">
                            {item.dob !== "" &&
                                <div className="play-card-body-item">
                                    <span>DOB</span>
                                    <span>{item.dob}</span>
                                </div>
                            }
                            {item.height !== "" &&
                                <div className="play-card-body-item">
                                    <span>Height</span>
                                    <span>{item.height}</span>
                                </div>
                            }
                            <div className="play-card-body-item">
                                <span>Origin</span>
                                <span>{item.origin}</span>
                            </div>
                        </div>
                        <div className="play-card-footer">
                            <div className="play-card-footer-item">
                                <span>games</span>
                                <span>{item.games}</span>
                            </div>
                            <div className="play-card-footer-item">
                                <span>goals</span>
                                <span>{item.goals}</span>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export class SubPlayer extends Component {
    constructor(p) {
        super(p);
        this.state = {

        }
    }

    onDragOver(e) {
        e.preventDefault()
        return false;
    }

    onDrop(e) {
        if (this.props.canDrop) {
            var obj = JSON.parse(e.dataTransfer.getData('application/json'));
            if (obj.fromLineUp) {
                this.props.setPlayer(obj, this.props.pos)
            }
        }
        e.preventDefault();
    }

    onMouseDown(e) {
        var elm = document.elementFromPoint(e.clientX, e.clientY);
    }

    onDragStart(e) {
        const item = this.props.player
        delete item.fromLineUp;
        item.fromSub = true
        e.dataTransfer.setData('application/json', JSON.stringify(item));
    }

    render() {
        const item = this.props.player
        return (
            <div
                className={(this.props.isDragging) ? "soccer-ground-field-layer-sub ready" : "soccer-ground-field-layer-sub"}
                ref={"node"}
                draggable={this.props.isDragging}
                id={'item_' + this.props.id}
                onMouseDown={this.onMouseDown.bind(this)}
                onDragStart={this.onDragStart.bind(this)}
                onDragOver={this.onDragOver.bind(this)}
                onDrop={this.onDrop.bind(this)}
                tabIndex={0}
            >
                {!this.props.canDrop &&
                    <img src={item.image} />
                }
                {!this.props.canDrop &&
                    <div className="play-card">
                        <div className="play-card-head">
                            <span>{item.name}</span>
                        </div>
                        <div className="play-card-body">
                            {item.dob !== "" &&
                                <div className="play-card-body-item">
                                    <span>DOB</span>
                                    <span>{item.dob}</span>
                                </div>
                            }
                            {item.height !== "" &&
                                <div className="play-card-body-item">
                                    <span>Height</span>
                                    <span>{item.height}</span>
                                </div>
                            }
                            <div className="play-card-body-item">
                                <span>Origin</span>
                                <span>{item.origin}</span>
                            </div>
                        </div>
                        <div className="play-card-footer">
                            <div className="play-card-footer-item">
                                <span>games</span>
                                <span>{item.games}</span>
                            </div>
                            <div className="play-card-footer-item">
                                <span>goals</span>
                                <span>{item.goals}</span>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export class PlayerItem extends Component {
    constructor(p) {
        super(p);
        this.state = {

        }
    }

    onMouseDown(e) {
        var elm = document.elementFromPoint(e.clientX, e.clientY);
        //this.props.updateStateDragging(this.props.id, true);
    }
    onMouseUp(e) {
        //this.props.updateStateDragging(this.props.id, false);
    }

    onDragStart(e) {
        const nodeStyle = this.refs.player.style;
        const item = this.props.player;
        const evt = e || window.event;
        var posX = e.clientX;
        var posY = e.clientY;
        var aX = posX - parseInt(nodeStyle.left);
        var aY = posY - parseInt(nodeStyle.top);
        //var boun = this.props.getParent().offsetWidth - this.refs.player.offsetWidth;
        const player = item;
        player.fromLineUp = true
        player.isHidden = false

        e.dataTransfer.setData('application/json', JSON.stringify(player));
    }

    onMouseMove(e) {
        const nodeStyle = this.refs.node.style;
        e.dataTransfer.setData('application/json', JSON.stringify({
            id: this.props.id,
            // mouse position in a draggable element
            x: e.clientX - parseInt(nodeStyle.left),
            y: e.clientY - parseInt(nodeStyle.top),
        }));
    }

    onDragEnd(e) {
        //this.props.updateStateDragging(this.props.id, false);
    }

    render() {
        const item = this.props.player
        return (
            <div
                className={(this.props.isSelected) ? "soccer-ground-player-list-item" : "soccer-ground-player-list-item disabled"}
                ref={"player"}
                id={'item_' + item.id}
                draggable={this.props.isSelected}
                onMouseDown={this.onMouseDown.bind(this)}
                onMouseUp={this.onMouseUp.bind(this)}
                onDragStart={this.onDragStart.bind(this)}
                onDragEnd={this.onDragEnd.bind(this)}>
                <img draggable={this.props.isSelected} src={item.image} />
                <span draggable={this.props.isSelected}>{item.name + " - " + item.position + " - " + item.number}</span>
            </div>
        );
    }
}

export class Ball extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onMouseDown(e) {
        var elm = document.elementFromPoint(e.clientX, e.clientY);
        //this.props.updateStateDragging(this.props.id, true);
    }
    onMouseUp(e) {
        //this.props.updateStateDragging(this.props.id, false);
    }

    onDragStart(e) {
        const nodeStyle = this.refs.node.style;
        const offset = window.$(this.props.getParent()).offset;
        const w = window.$(this.props.getParent()).width();
        const h = window.$(this.props.getParent()).height();
        const left = (parseInt(nodeStyle.left) / 100) * w;
        const top = (parseInt(nodeStyle.top) / 100) * h;
        //console.log("Dragged I", left, top)
        //console.log("Dragged E", e.clientX, e.clientY)
        const evt = e || window.event;
        var posX = e.clientX;
        var posY = e.clientY;
        var aX = posX - left;
        var aY = posY - top;
        var boun = this.props.getParent().offsetWidth - this.refs.node.offsetWidth;
        if ((aX > 0) && (aX < boun) && (aY > 0) && (aY < boun)) {
            e.dataTransfer.setData('application/json', JSON.stringify({
                isBall: true,
                // mouse position in a draggable element
                x: aX,
                y: aY,
            }));
        }
    }

    onMouseMove(e) {
        const nodeStyle = this.refs.node.style;
        e.dataTransfer.setData('application/json', JSON.stringify({
            id: this.props.id,
            // mouse position in a draggable element
            x: e.clientX - parseInt(nodeStyle.left),
            y: e.clientY - parseInt(nodeStyle.top),
        }));
    }

    onDragEnd(e) {
        //this.props.updateStateDragging(this.props.id, false);
    }

    onTouchStart(e) {
        e = e.targetTouches[0]
        const nodeStyle = this.refs.node.style;
        const offset = window.$(this.props.getParent()).offset;
        const w = window.$(this.props.getParent()).width();
        const h = window.$(this.props.getParent()).height();
        const left = (parseInt(nodeStyle.left) / 100) * w;
        const top = (parseInt(nodeStyle.top) / 100) * h;
        console.log("Dragged I", left, top)
        console.log("Dragged E", e.pageX, e.pageY)
        const evt = e || window.event;
        var posX = e.pageX;
        var posY = e.pageY;
        var aX = posX - left;
        var aY = posY - top;
        console.log(aX, aY)
        var boun = this.props.getParent().offsetWidth - this.refs.node.offsetWidth;
        if ((aX > 0) && (aX < boun) && (aY > 0) && (aY < boun)) {
            this.props.dataBallTransfer({
                isBall: true,
                // mouse position in a draggable element
                x: aX,
                y: aY,
            });
        }
    }

    render() {
        const styles = {
            top: this.props.top,
            left: this.props.left,
            opacity: (this.props.isHidden) ? 0 : 1
        };
        return (
            <div className="pitch-ball"
                ref={"node"}
                draggable={this.props.isDragging}
                id={this.props.id}
                style={styles}
                onMouseDown={this.onMouseDown.bind(this)}
                onMouseUp={this.onMouseUp.bind(this)}
                onDragStart={this.onDragStart.bind(this)}
                onTouchStart={this.onMouseDown.bind(this)}
                onTouchEnd={this.onMouseUp.bind(this)}
                onTouchMove={this.onTouchStart.bind(this)}
                onDragEnd={this.onDragEnd.bind(this)}
                tabIndex={0}
            >

            </div>
        );
    }
}

class Frame {
    lineup = [];
    subs = []
    id = null;

    constructor(id, lineup, subs) {
        this.subs = subs;
        this.lineup = lineup;
        this.id = id;
    }

    getLineup() {
        return this.lineup;
    }

    getSubs() {
        return this.subs;
    }

    getId() {
        return this.id
    }
}


// WEBPACK FOOTER //
// ./src/components/SoccerPitch.js